<div *ngIf="!apiKeys">
  <div class="mb-1">Please, enter your password to unlock</div>
  <mat-form-field>
    <mat-label>Password</mat-label>
    <input matInput type="password" [(ngModel)]="password" />
  </mat-form-field>
  <button class="ml-2" mat-button mat-raised-button (click)="loadKeys()">
    Get Keys
  </button>
</div>
<div class="users-component" style="height: 100%" *ngIf="apiKeys" class="m-2">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div style="display: flex; flex-direction: row; margin-top: 16px">
      <form class="example-form">
        <button mat-raised-button (click)="create()" style="border-radius: 6px">
          Add Key
        </button>
      </form>
    </div>
  </div>

  <p-table
    [value]="apiKeys"
    [rows]="100"
    [paginator]="true"
    [style]="{ 'margin-top': '10px' }"
    #table
    dataKey="roleGroup"
  >
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap; font-weight: bold">
        <th *ngFor="let col of cols">
          {{ col.header }}
        </th>
        <th style="width: 10em">GET</th>
        <th style="width: 10em">POST</th>
        <th style="width: 15em"></th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field">
          <input
            *ngSwitchDefault
            pInputText
            type="text"
            placeholder="⌕"
            (input)="
              table.filter($event.target['value'], col.field, 'contains')
            "
          />
          <span *ngSwitchCase="'role'"></span>
        </th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td>
          <span>{{ item.key }}</span
          ><i
            class="pi pi-copy"
            (click)="clipboard(item.key)"
          ></i>
        </td>
        <td>
          <input
            type="checkbox"
            [checked]="item.isGet"
            (change)="setIsGet(item.id, $event.target['checked'])"
          />
        </td>
        <td>
          <input
            type="checkbox"
            [checked]="item.isPost"
            (change)="setIsPost(item.id, $event.target['checked'])"
          />
        </td>
        <td>
          <button
            type="button"
            pButton
            class="risksponge-button"
            (click)="delete(item.id)"
            title="Edit user"
            icon="pi pi-trash"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
